module.exports = __webpack_public_path__ + "90f4669c43feae5adad51d34b02249e7.MP3";